import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainNavbar = _resolveComponent("MainNavbar")!
  const _component_HomeHero = _resolveComponent("HomeHero")!
  const _component_HomeAbout = _resolveComponent("HomeAbout")!
  const _component_HomeMenu = _resolveComponent("HomeMenu")!
  const _component_HomeCTA = _resolveComponent("HomeCTA")!
  const _component_HomeInvestment = _resolveComponent("HomeInvestment")!
  const _component_FranchiseContact = _resolveComponent("FranchiseContact")!
  const _component_HomeContact = _resolveComponent("HomeContact")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MainNavbar, { class: "style-three" }),
    _createVNode(_component_HomeHero),
    _createVNode(_component_HomeAbout),
    _createVNode(_component_HomeMenu),
    _createVNode(_component_HomeCTA),
    _createVNode(_component_HomeInvestment),
    _createVNode(_component_FranchiseContact),
    _createVNode(_component_HomeContact)
  ], 64))
}